import * as React from "react";

type FilterIconProps = React.SVGProps<SVGSVGElement> & {
  circleColor?: string;
  strokeColor?: string;
};

const FilterIcon = ({
  circleColor = "#1B365E",
  strokeColor = "#ffffff",
  ...props
}: FilterIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <circle cx="12" cy="12" r="12" fill={circleColor} />

      <path
        d="M10.7273 9.27273L19 9.27273M10.7273 9.27273C10.7273 9.97564 10.1575 10.5455 9.45455 10.5455C8.75164 10.5455 8.18182 9.97563 8.18182 9.27273M10.7273 9.27273C10.7273 8.56982 10.1575 8 9.45455 8C8.75164 8 8.18182 8.56982 8.18182 9.27273M5 9.27273H8.18182M15.8182 14.3636L19 14.3636M15.8182 14.3636C15.8182 15.0665 15.2484 15.6364 14.5455 15.6364C13.8425 15.6364 13.2727 15.0665 13.2727 14.3636M15.8182 14.3636C15.8182 13.6607 15.2484 13.0909 14.5455 13.0909C13.8425 13.0909 13.2727 13.6607 13.2727 14.3636M5 14.3636H13.2727"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FilterIcon;
